import { useRef, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { DetailForm } from './detail-form';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import accountForms from 'src/api/accounts/vm-form';
import studentForms from 'src/api/students/vm-form';
import useToast from 'src/utils/toast-utils';
import { useCallbackAction } from 'src/hooks/use-actions';
import PageSection from 'src/layouts/page-section';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';

const Page = ({ onNavigate, item }) => {
  // console.log('========== ITEM', item);
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const router = useRouter();

  const { blockAccount } = accountForms();
  const { insertStudent, updateStudent } = studentForms();
  const { toastSuccess, toastError } = useToast();
  
  const apiInsert = (values) => useCallbackAction(insertStudent, values, 
          (result) => {
            toastSuccess(`Học viên ${result.code} đã được tạo`);
            childRef.current?.setDataFromParent(result); 
          }, toastError);

  const apiUpdate = (values) => useCallbackAction(updateStudent, values, (result) => {
          toastSuccess(`Học viên ${item.code} đã cập nhật`, {action: 'back'});
  }, toastError);

  const apiRemove = (values) => useCallbackAction(blockAccount, values, 
          (result) => {
            toastSuccess(`Đã khóa ${item.code}`, {action: 'back'}); 
          }, toastError);

  return (
    <PageSection title="Student" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.students)}
          subLabel={item.code}
        />
        <DetailForm
          ref={childRef}
          item={item}
          apiInsert={apiInsert}
          apiUpdate={apiUpdate}
          apiRemove={apiRemove}
        />
      </Stack>
    </PageSection>
  );
};

export default Page;
